import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    root: {
      position: "fixed",
      bottom: 0,
      right: 0,
      width: "calc(100% - 221px)",
      height: 88,
      display: "flex",
      justifyContent: "space-between",
      padding: "16px 24px 26px",
      backgroundColor: "#fff",
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        width: "calc(100% - 85px)"
      },
      borderTop: `1px solid ${primary.light}`,
      zIndex: 1300
    },
    button: {
      width: 188,
      height: 46,
      borderRadius: 2,
      letterSpacing: 0.5,
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none"
      }
    },
    saveAndCloseButton: {
      color: "#333",
      border: "1px solid #033333"
    },
    reviewFormButton: {
      color: "#fff",
      backgroundColor: secondary.dark,
      "&:hover": {
        backgroundColor: secondary.dark
      }
    }
  };
});
